import * as React from 'react';
import Text from './Text';
import { belarusify } from '../util/belarusify';


function TextCyrillic({ value, onChange }) {
  const handleChange = (event) => {
    onChange(belarusify(event.target.value))
  }

  return <Text
    label="Кірыліца"
    value={value}
    onChange={handleChange}
    autoFocus={true}
  />;
}

TextCyrillic.defaultProps = {
  value: "",
  onChange: () => { }
}

export default TextCyrillic;